const drawerWidth = 270;
const styles = theme => ({
  drawerPaper: {
    width: 250,
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 10px',
    zDepth:0,
    width: drawerWidth,
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
    },
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      marginTop: 64,
      position: 'fixed',
      height: `calc(100% - 64px)`,
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/SideDrawer/styles.js